/**
 * React app configuration. Indicates which config app actually uses.
 */ export var defaultConfiguration = {
    baseRoute: '',
    identityUrl: '',
    staticApiUrl: '',
    tenant: '',
    onlineBaseUrl: '',
    userName: '',
    antiForgeryToken: '',
    returnUrl: '',
    allowedPhoneFormats: [],
    availablePasswordRecoveryChannels: [],
    availableTenants: [],
    externalProviders: [],
    externalAccount: {
        loginProvider: '',
        providerKey: ''
    },
    countries: [],
    status: 0,
    clientId: '',
    currentLanguage: ''
};
var NotificationChannel = /*#__PURE__*/ function(NotificationChannel) {
    NotificationChannel[NotificationChannel["Email"] = 0] = "Email";
    NotificationChannel[NotificationChannel["Sms"] = 1] = "Sms";
    NotificationChannel[NotificationChannel["WhatsApp"] = 2] = "WhatsApp";
    return NotificationChannel;
}(NotificationChannel || {});
export var MessageStatus = /*#__PURE__*/ function(MessageStatus) {
    MessageStatus[MessageStatus["Ok"] = 0] = "Ok";
    MessageStatus[MessageStatus["InvalidModelState"] = 1] = "InvalidModelState";
    MessageStatus[MessageStatus["InvalidUsernameOrPassword"] = 2] = "InvalidUsernameOrPassword";
    MessageStatus[MessageStatus["UserLockedOut"] = 3] = "UserLockedOut";
    MessageStatus[MessageStatus["UserNotAllowed"] = 4] = "UserNotAllowed";
    MessageStatus[MessageStatus["RequiresTwoFactor"] = 5] = "RequiresTwoFactor";
    MessageStatus[MessageStatus["NeedsToChangePassword"] = 6] = "NeedsToChangePassword";
    return MessageStatus;
}({});
